import React from 'react';

const WindowChoose = (data) => {

  let icon = { backgroundImage: `url(${data.icon})` };

  return (
    <>
      <div className="description-box-2">
        <div>
          <div className="choose-icon-summary" style={icon}></div>
          <div className="choose-text">{data.index}. {data.text}</div>
        </div>
      </div>
      <br />
    </>
  );
};

export default WindowChoose;